import { jsx as _jsx } from "react/jsx-runtime";
import { VehicleCard as SharedVehicleCard } from "@cinch-nx/landing-ui-shared";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import styles from "./cards.module.css";
export const VehicleCard = ({ vehicle , carouselName  })=>{
    const { trackEvent  } = useAnalytics();
    const handleClick = ()=>{
        trackEvent({
            eventName: `Car Rewiew - PDP Cards Latest Vehicle ${vehicle.make} ${vehicle.model}`,
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: `car review ${carouselName === null || carouselName === void 0 ? void 0 : carouselName.replace("-", " ")}`,
                    label: vehicle.vehicleId,
                    action: "Open"
                }
            }
        });
    };
    return /*#__PURE__*/ _jsx("div", {
        className: styles.vehicleCardContainer,
        children: /*#__PURE__*/ _jsx(SharedVehicleCard, {
            id: vehicle.vehicleId,
            isSaved: false,
            isPending: vehicle.isReserved,
            isAvailable: vehicle.isAvailable,
            vehicle: vehicle,
            isSmallCardSize: true,
            onCardClick: handleClick,
            isPersonalised: true
        }, vehicle.vehicleId)
    });
};
export const VehicleCardsList = ({ vehicles , carouselName  })=>/*#__PURE__*/ _jsx("ul", {
        className: styles.vehicleCardList,
        "aria-label": carouselName,
        children: vehicles.map((vehicle)=>/*#__PURE__*/ _jsx("li", {
                children: /*#__PURE__*/ _jsx(VehicleCard, {
                    vehicle: vehicle,
                    carouselName: carouselName
                }, vehicle.vehicleId)
            }, vehicle.vehicleId))
    });
